module.exports = __webpack_public_path__ + "img/dacia_logo.0ad1ea29.svg";